import { SegmentEvent } from '@segment/analytics-next';

export class AnalyticsServiceClient {
  constructor(private baseURL: string) {}

  private static serializeEvent(event: SegmentEvent) {
    return {
      messageId: event.messageId,
      name: event.name,
      properties: event.properties,
      context: {
        ip: event.context?.ip,
        locale: event.context?.locale,
        location: event.context?.location,
        page: event.context?.page,
        userAgent: event.context?.userAgent,
        campaign: event.context?.campaign,
        referrer: event.context?.referrer,
      },
      userId: event.userId,
      anonymousId: event.anonymousId,
      previousId: event.previousId,
      event: event.event,
      sentAt: event.sentAt?.toISOString(),
      timestamp:
        event.timestamp != null && event.timestamp instanceof Date ? event.timestamp.toISOString() : event.timestamp,
    };
  }

  async track(event: SegmentEvent) {
    await fetch(`${this.baseURL}/t/track`, {
      method: 'POST',
      headers: {
        // Avoids sending an OPTION request before sending the POST
        'Content-Type': 'text/plain',
      },
      body: JSON.stringify(AnalyticsServiceClient.serializeEvent(event)),
    });
  }

  async page(event: SegmentEvent) {
    await fetch(`${this.baseURL}/t/page`, {
      method: 'POST',
      headers: {
        // Avoids sending an OPTION request before sending the POST
        'Content-Type': 'text/plain',
      },
      body: JSON.stringify(AnalyticsServiceClient.serializeEvent(event)),
    });
  }
}
